var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._g(_vm._b({attrs:{"rules":_vm.warehouseRules,"label":"Warehouse","data-track":"warehouse","dense":"","clearable":"","outlined":"","required":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }